import { usStates } from './usStates';
import { usStatesShortCodes } from './usStatesShortCodes';
import { caProvinces } from './caProvinces';
import { caProvincesShortCodes } from './caProvincesShortCodes';
import { auStates } from './auStates';
import { auStatesShortCodes } from './auStatesShortCodes';

const zipToMaps = ({ names, codes }) => {
	const codeToName = {};
	const nameToCode = {};

	const len = Math.min(names.length, codes.length);
	for (let i = 0; i < len; i += 1) {
		const name = names[i];
		const code = codes[i];
		if (!name || !code) continue;
		codeToName[code] = name;
		nameToCode[name] = code;
	}

	return { codeToName, nameToCode };
};

const US = zipToMaps({ names: usStates, codes: usStatesShortCodes });
const CA = zipToMaps({ names: caProvinces, codes: caProvincesShortCodes });
const AU = zipToMaps({ names: auStates, codes: auStatesShortCodes });

export const regionMaps = { US, CA, AU };

export const toRegionName = ({ country, codeOrName }) => {
	const c = String(country || '').toUpperCase();
	const v = String(codeOrName || '').trim();
	if (!v) return '';
	const maps = regionMaps[c];
	if (!maps) return v;
	return maps.codeToName[v.toUpperCase()] || v;
};

export const toRegionCode = ({ country, codeOrName }) => {
	const c = String(country || '').toUpperCase();
	const v = String(codeOrName || '').trim();
	if (!v) return '';
	const maps = regionMaps[c];
	if (!maps) return v.toUpperCase();
	if (maps.nameToCode[v]) return maps.nameToCode[v];
	const upper = v.toUpperCase();
	if (maps.codeToName[upper]) return upper;
	const match = Object.keys(maps.nameToCode).find(
		(name) => name.toUpperCase() === upper,
	);
	return match ? maps.nameToCode[match] : upper;
};

